import { useState } from "react";
import LiveEnergyFlowCard from "../../../shared/components/live-energy-flow-card/live-energy-flow-card";
import Reveal from "../../../shared/components/reveal/reveal";
import AppToggle from "../../../shared/oversight-core/ui-elements/app-toggle/app-toggle";
import MaterialIcon from "../../../shared/oversight-core/ui-elements/material-icon/material-icon";
import styles from "./dlb.module.scss";

const DLB = () => {
  const [isGridDlbOn, setIsGridDlbOn] = useState(false);
  const [isExtremeModeOn, setIsExtremeModeOn] = useState(false);
  const [isDlbBoxSelected, setIsDlbBoxSelected] = useState(false);

  const handleGridDlbSwitch = (isOn: boolean) => {
    setIsGridDlbOn(isOn);
    if (!isOn) {
      setIsExtremeModeOn(false);
      setIsDlbBoxSelected(false);
    }
  };

  return (
    <div className={styles.dlbContainer}>
      <Reveal className={styles.energyFlowWrapper}>
        <LiveEnergyFlowCard
          showHeader={false}
          grid={{ direction: "in", active: true }}
          solar={{ direction: "in", active: false }}
          ev={{ direction: "out", active: true }}
          load={{ direction: "out", active: true }}
        />
      </Reveal>
      <Reveal delay={110} className="w-100" style={{ maxWidth: 400 }}>
        <div className={styles.settingsCard}>
          <div className={styles.settingRow}>
            <div className="d-flex align-items-center gap-2">
              <MaterialIcon icon="tune" size={22} color="var(--dark)" />
              <span className="text-dark font-size-14 font-weight-400">
                Grid Dynamic Load Balance
              </span>
            </div>
            <AppToggle isOn={isGridDlbOn} onSwitch={handleGridDlbSwitch} />
          </div>

          <div
            className={`${styles.settingsPanel} ${
              isGridDlbOn ? styles.settingsPanelOpen : ""
            }`}
            aria-hidden={!isGridDlbOn}
          >
            <div className={styles.settingsPanelInner}>
              <div className={styles.divider} />
              <div className={styles.settingRow}>
                <div className="d-flex align-items-center gap-2">
                  <MaterialIcon
                    icon="all_inclusive"
                    size={22}
                    color="var(--dark)"
                  />
                  <span className="text-dark font-size-14 font-weight-400">
                    Extreme Mode
                  </span>
                </div>
                <AppToggle
                  isOn={isExtremeModeOn}
                  onSwitch={setIsExtremeModeOn}
                  disabled={!isGridDlbOn}
                />
              </div>

              <div className={styles.divider} />
              <button
                type="button"
                className={styles.settingRowButton}
                onClick={() => setIsDlbBoxSelected((prev) => !prev)}
                aria-pressed={isDlbBoxSelected}
                disabled={!isGridDlbOn}
                tabIndex={isGridDlbOn ? 0 : -1}
              >
                <div className="d-flex align-items-center gap-2">
                  <MaterialIcon
                    icon="inventory_2"
                    size={22}
                    color="var(--dark)"
                  />
                  <span className="text-dark font-size-14 font-weight-400">
                    DLB Box
                  </span>
                </div>
                <span
                  className={`${styles.radioIndicator} ${
                    isDlbBoxSelected ? styles.radioSelected : ""
                  }`}
                  aria-hidden
                />
              </button>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  );
};

export default DLB;
